import type { ReactElement } from 'react'

import { Typography } from '@twisto/components/atoms/typography'
import type { IconComponent } from '@twisto/icons'

import * as styles from './message-box.styles'

export type Colors = 'primary' | 'success' | 'warning' | 'gray'

type Props = {
  icon: IconComponent
  children: ReactElement | string
  color: Colors
  className?: string
}

export const MessageBox = ({ icon, children, color, className }: Props) => {
  const Icon = icon

  return (
    <div
      className={className}
      css={(theme) => [styles.box, styles.background[color](theme)]}
      data-testid="message-box"
    >
      <Icon color={color} size="24" />
      <Typography variant="b4">{children}</Typography>
    </div>
  )
}
